let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7er38")).then(() => parcelRequire('vvebX'));